import type { ReactNode } from 'react';

type StatsGridColumns = 3 | 4 | 5;

type StatsGridProps = {
  children: ReactNode;
  /** Wide-viewport column count. Defaults to 4 to match existing pages. */
  columns?: StatsGridColumns;
};

const wideColumnsClass: Record<StatsGridColumns, string> = {
  3: 'xl:grid-cols-3',
  4: 'xl:grid-cols-4',
  5: 'lg:grid-cols-3 xl:grid-cols-5',
};

export function StatsGrid({ children, columns = 4 }: StatsGridProps) {
  return (
    <div className={`grid grid-cols-1 gap-4 sm:grid-cols-2 ${wideColumnsClass[columns]}`}>
      {children}
    </div>
  );
}
